import { useState } from 'react';
import PropTypes from 'prop-types';

import { Tabs } from '@spotahome/ui-library';

import DropdownTabs from './DropdownTabs';

import './ChartContainer.scss';
import ToggleViewButton from './ToggleViewButton';

const ChartContainer = ({
  isMobile = false,
  title,
  subtitle,
  summary,
  activeIndex = 0,
  onTabChange,
  renderChart,
  renderTable,
  sections = []
}) => {
  const [isViewTable, setIsViewTable] = useState(false);

  const handleToggleView = () => {
    setIsViewTable(prev => !prev);
  };

  const chartSections = sections.map(section => ({
    ...section,
    render: () => renderChart()
  }));

  const tableSections = sections.map(section => ({
    ...section,
    render: () => renderTable()
  }));

  return (
    <div className="chart-container">
      <div className="chart-container__header">
        <h3 className="chart-container__header-title">{title}</h3>
        <ToggleViewButton
          className="chart-container__header-button"
          onClick={handleToggleView}
          isViewTable={isViewTable}
        />
      </div>
      <div className="chart-container__subtitle">
        {/* eslint-disable-next-line react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: subtitle }} />
      </div>
      <div className="chart-container__chart">
        {sections.length > 0 &&
          (isMobile ? (
            <DropdownTabs
              className="chart-container__chart-tabs"
              items={isViewTable ? tableSections : chartSections}
              variant={'outlined'}
              onChange={onTabChange}
              activeIndex={activeIndex}
              handleOnClick={handleToggleView}
              isViewTable={isViewTable}
            />
          ) : (
            <Tabs
              className="chart-container__chart-tabs"
              tabClassName="chart-container__chart-tab"
              items={isViewTable ? tableSections : chartSections}
              variant={'outlined'}
              onChange={onTabChange}
              activeIndex={activeIndex}
            />
          ))}
        {sections.length === 0 && (
          <>
            <div className="chart-container__mobile-button-container">
              <ToggleViewButton
                className="chart-container__mobile-button"
                isViewTable={isViewTable}
                onClick={handleToggleView}
              />
            </div>
            {isViewTable ? renderTable() : renderChart()}
          </>
        )}
      </div>
      <p
        className="chart-container__description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: summary }}
      />
    </div>
  );
};

export default ChartContainer;

ChartContainer.propTypes = {
  isMobile: PropTypes.bool,
  location: PropTypes.shape({
    city: PropTypes.string,
    country: PropTypes.string
  }).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeIndex: PropTypes.number,
  onTabChange: PropTypes.func.isRequired,
  renderChart: PropTypes.func.isRequired,
  renderTable: PropTypes.func.isRequired
};
